import React from "react";
import PropTypes from "prop-types";

/**
 * Template generico della pagina
 * Contiene il contenuto della pagina.
 * @component
 */
const PageTemplate = (props) => {
  const { BodyComponent, title, ...rest } = props;

  return (
    <div className='main-container'>
      <div className='body-wrapper'>
        <BodyComponent title={title} {...rest} />
      </div>
    </div>
  );
};

PageTemplate.propTypes = {
  breadcrumb: PropTypes.string,
  /** BodyComponent: required content */
  BodyComponent: PropTypes.elementType.isRequired,
  /** title: string. CrmHeader prop */
  title: PropTypes.string,
  /** goBack: boolean. CrmHeader prop */
  goBack: PropTypes.bool,
};

PageTemplate.defaultProps = {
  title: "",
  goBack: false,
};

export default PageTemplate;
